import Chart from "chart.js";
class BarChartControl {
	
	constructor(node, dataSource, Configuration) {
		let { dataParser,updateDispatchers,updateFunction, plugins} = Configuration;
		let parsedData = dataParser(dataSource);
		this._handlePrintRequest = Configuration.handlePrintRequest;
		this._handleDownloadRequest = Configuration.handleDownloadRequest;
		this._resizeOverLay = node.querySelector(`[control-role="resize-overlay"]`);
		this._updateFunction=updateFunction;
		this._data = parsedData.data;
		this._options = parsedData.options;
		this._documentTitle = parsedData.data.documentTitle;
		this._plugins =plugins;
		this._resizeTimer = null;
		this._node = node;
		this._addDownloadListeners();
		this._addPrintListeners();
		this._render(node);
		this.registerUpdateDispatchers(updateDispatchers);
		this.registerWindowResizeEvent(node);
		this.registerPrintEvents();
		
	}

	registerPrintEvents(){
		  window.addEventListener('afterprint', () => {
			document.body.classList.remove('print-chart');
			this._chart.resize();
		  });
	}

	registerWindowResizeEvent(node){
		window.addEventListener('resize',(e)=>{
			clearTimeout(this._resizeTimer);
			//this._chart.stop();
			this._resizeOverLay.classList.remove('hidden');
			this._resizeTimer = setTimeout(() => {
				this._chart.resize();
				this._resizeOverLay.classList.add('hidden');
			}, 300);
			
		});
	}

	registerUpdateDispatchers(updateDispatchers){
		if(!updateDispatchers){
			return;
		}
		
		for(var i = 0;i<updateDispatchers.length;i++){
			let updateDispatcher = updateDispatchers[i];
			updateDispatcher.addEventListener('update',this.update.bind(this));
		}

	}

	update(){
		if(this._updateFunction){	
			this._updateFunction(this._chart);

		}else{
			this._chart.update();	
		}
		
	
	}
	_render(node) {
		let chartCanvas = node.querySelector("[control-role='chartCanvas']");
		var ctx = chartCanvas.getContext("2d");
		var chart = new Chart(ctx, {
			type: 'bar',
			data:this._data,
			options:this._options,
			plugins:this._plugins
		});
		this._chart = chart;
		this._chart.resize();		
	};

	_addDownloadListeners(){
		let downloadButtons = document.querySelectorAll("[control-role='chartDownload']");
		for(var i = 0;i<downloadButtons.length;i++){
			downloadButtons[i].addEventListener('click',this.onDownLoadClicked.bind(this));
		}
	}

	_addPrintListeners(){
		let printButtons = document.querySelectorAll("[control-role='chartPrint']");
		for(var i = 0;i<printButtons.length;i++){
			printButtons[i].addEventListener('click',this.onPrintClicked.bind(this));
		}
	}

	onPrintClicked(){
		document.body.classList.add('print-chart');
		this._chart.resize();
		if(this._handlePrintRequest){
			this._handlePrintRequest(this._chart);
		}else{
			window.print();
		}
		
	}

	onDownLoadClicked(){
		if(this._handleDownloadRequest){
			this._handleDownloadRequest(this._chart,this._documentTitle);

		}else{
			var element = document.createElement("a");
			element.setAttribute(
				"href",
				this._chart.toBase64Image()
			);
			element.setAttribute("download", `${this._documentTitle}.png`);
		
			element.style.display = "none";
			document.body.appendChild(element);
		
			element.click();
		
			document.body.removeChild(element);
		}
	
	}
}

export default BarChartControl;
